// src/context/ScoreContext.tsx
import React, { createContext, useContext, useState, useCallback } from 'react';

interface ScoreContextType {
  refreshKey: number;
  triggerRefresh: () => void;
}

const ScoreContext = createContext<ScoreContextType | undefined>(undefined);

export const ScoreProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const triggerRefresh = useCallback(() => {
    setRefreshKey(prev => prev + 1);
  }, []);

  return (
    <ScoreContext.Provider value={{ refreshKey, triggerRefresh }}>
      {children}
    </ScoreContext.Provider>
  );
};

export const useScoreContext = () => {
  const context = useContext(ScoreContext);
  if (!context) throw new Error("useScoreContext must be used within ScoreProvider");
  return context;
};
